<script setup lang="ts">
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'

const props = defineProps<{
  showText?: boolean
  to: string
  label: string
  target?: '_blank' | '_self'
  isActive?: boolean
  iconClass?: string
}>()

const titleRef = ref(props.label)

const handleMouseEnter = (e: MouseEvent) => {
  const target = e.currentTarget as HTMLElement
  target.removeAttribute('title')
}

const handleMouseLeave = (e: MouseEvent) => {
  const target = e.currentTarget as HTMLElement
  target.setAttribute('title', titleRef.value)
}
</script>

<template>
  <NuxtLink
    :to="to"
    :target="target"
    :title="label"
    class="flex py-2 gap-2 color-softBlack sm:color-darkGray transition-colors sm:hover:color-softBlack active:color-softBlack"
    :class="[
      isActive && 'color-softBlack sm:color-softBlack',
    ]"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <div
      v-if="$slots.default" :class="[
        !iconClass && 'px-1',
        iconClass,
      ]"
    >
      <TooltipProvider :disabled="showText" class="!box-shadow-none" :delay-duration="0">
        <Tooltip>
          <TooltipTrigger as-child>
            <slot />
          </TooltipTrigger>
          <TooltipContent show-arrow class="flex items-center gap-2" side="right">
            <p>{{ label }}</p>
            <slot name="suffix" />
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>

    <TransitionFade>
      <div v-if="showText" class="flex items-center gap-2">
        <TextV2 class="font-bold whitespace-nowrap">
          {{ label }}
        </TextV2>

        <slot name="suffix" />
      </div>
    </TransitionFade>
  </NuxtLink>
</template>

<style lang="scss" scoped></style>
